import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { isTooManyEmailVerificationRequestsError } from '../../util/errors';
import { PrimaryButton, NamedLink } from '../../components';
import classNames from 'classnames';
import config from '../../config';

import { SignupProgressBar } from './SignupWizard';
import css from './SignupPage.module.css';

const EmailVerification = props => {
  const {
    user,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    onResendVerificationEmail,
  } = props;
  const resendErrorTranslationId = isTooManyEmailVerificationRequestsError(
    sendVerificationEmailError
  )
    ? 'AuthenticationPage.resendFailedTooManyRequests'
    : 'AuthenticationPage.resendFailed';
  const resendErrorMessage = sendVerificationEmailError ? (
    <p className={css.error}>
      <FormattedMessage id={resendErrorTranslationId} />
    </p>
  ) : null;

  const name = user.attributes.profile.firstName;
  const email = <strong>{user.attributes.email}</strong>;

  // Determine redirect based on user role
  const userRole = user?.attributes?.profile?.publicData?.role;
  const organizationProfiles = user?.attributes?.profile?.publicData?.organizationProfiles || [];
  const isOrganization = userRole === config.userRoles['organization'];
  const isCreator = userRole === config.userRoles['creator'];

  // For organizations, redirect directly to their org dashboard with orgId
  // This avoids DashboardPage's localStorage priority which might redirect to creator
  let skipRedirectPage = 'LandingPage';
  let skipRedirectParams = {};

  if (isOrganization && organizationProfiles.length > 0) {
    skipRedirectPage = 'OrganizationHomePage';
    skipRedirectParams = { orgId: organizationProfiles[0].id };
  } else if (isCreator) {
    skipRedirectPage = 'CreatorHomePage';
  }

  return (
    <div className={classNames(css.content, css.emailVerificationContent)}>
      {/* Progress bar at 100% */}
      <SignupProgressBar progress={100} />

      {/* Step header without back arrow */}
      <div className={css.verifyStepHeader}>
        <span className={css.verifyStepIndicator}>
          <FormattedMessage id="SignupWizard.stepLabel" values={{ step: 3 }} />
        </span>
        <h1 className={css.verifyStepTitle}>
          <FormattedMessage id="SignupWizard.verifyStepTitle" />
        </h1>
      </div>

      {/* Message */}
      <p className={css.verifyMessage}>
        <FormattedMessage id="SignupWizard.verifyEmailMessage" values={{ name, email }} />
      </p>

      {resendErrorMessage}

      {/* Footer buttons */}
      <div className={css.verifyFooter}>
        <PrimaryButton
          className={css.verifyButton}
          onClick={onResendVerificationEmail}
          inProgress={sendVerificationEmailInProgress}
        >
          <FormattedMessage id="SignupWizard.resendVerification" />
        </PrimaryButton>
        <NamedLink
          className={css.verifySkipLink}
          name={skipRedirectPage}
          params={skipRedirectParams}
        >
          <FormattedMessage id="SignupWizard.skipVerification" />
        </NamedLink>
      </div>
    </div>
  );
};

export default EmailVerification;
